<template>
    <!-- Dashboard Content
      ================================================== -->
    <div class="dashboard-content-container" data-simplebar>

        <div class="dashboard-content-inner">
            <!-- Dashboard Headline -->
            <div class="dashboard-headline">
                <h3>All Projects</h3>

                <!-- Breadcrumbs -->
                <nav id="breadcrumbs" class="dark">
                    <ul>
                        <!--                   <router-link to="/admin">Admin</router-link>-->
                        <li><a href="/admin">Admin</a></li>
<!--                        <li><a href="/admin/locations/countries">Projects</a></li>-->
<!--                        <li><a href="#">{{ this.locationType }}</a></li>-->
                        <li>Projects</li>
                        <li>Published</li>
                    </ul>
                </nav>
            </div>

            <div class="col-xl-12">
                <br/>
                <div class="row">

                    <admin-projects-list status="published"></admin-projects-list>

                </div>
            </div>
        </div>
    </div>
    <!--            <app-footer></app-footer>-->
    <!-- Dashboard Content / End -->

</template>

<script>
    import AdminProjectsList from "./AdminProjectsList";

    export default {
        name: 'PublishedProjects',
        components: {AdminProjectsList},
        data() {
            return {

            }
        },

        computed: {
        },
        methods: {},
        created() {}
    };
</script>

<style scoped>
    .country-info {
        font-size: .7rem;
        color: #0fbaf1 !important;
    }
    .country-name {
        text-transform: uppercase;
        color: black;
    }
    .country-name::after {
        content: " ";
    }
    .search-info {
        margin: 0 auto;
        text-align: center;
        color: #0fbaf1 !important;
    }

</style>
